import classes from "./Profile.module.css"
import { useTranslation } from "react-i18next"
import { coopRareEnemy_dict, mode_dict, special_dict, useLocalStorage, weapon_dict } from "../../Utils"
import ProgressBar from "react-bootstrap/ProgressBar"
import BadgeInfoJson from "../../assets/json/parameters/BadgeInfo.json"
import { defaultProfile } from "../../DefaultEntries"
import { t } from "i18next"

export const filter_category = [
    "CatalogueLevel",
    "CoopBigRunTrophy",
    "CoopContestTrophy",
    "CoopClearDangerRateMax",
    "CoopGrade_Normal",
    "EventMatch",
    "FestRankMax",
    "Mission",
    "GearTotalRarity",
    "NawaBattlerCardNum",
    "NawaBattlerRank",
    "NawaBattlerWinAllNpcLevel3",
    "OrderFood",
    "OrderVendor",
    "SpendLottery",
    "SpendShop",
    "TotalKumaPoint",
    "Udemae",
    "WeaponLevel",
    "XRank",
    "SpendShop_Fsodr",
    "OrderVendor_Fsodr",
    "Fest10xBattle",
    "ChallengeWinStreak",
    "XRank_Revised",
    "WinCount_HighXPower",
    "XPower",
    "HammerHostTournament",
    "Achievement_Sdodr",
    "TipColorComplete_Sdodr",
    "SpendShop_Sdodr",
    "CoopKillTripleBoss",
]

const BadgePage = () => {
    return (
        <>
            <h2>{t("misc:Profile.BadgeProgress")}</h2>
            <hr />
            <div className={classes.BadgeList}>
                {BadgeInfoJson.filter(elem => !filter_category.includes(elem.Category)).map((entry, idx) => {
                    return <BadgeInfo key={idx} content={entry} />
                })}
            </div>
        </>
    )
}

const BadgeInfo = props => {
    const { t } = useTranslation()
    const [profile] = useLocalStorage("profile", defaultProfile)

    function format_description() {
        if (props.content.MsgLabelEx !== "") {
            let res = t("translation:CommonMsg.Badge.BadgeMsg." + props.content.MsgLabelEx)
            if (res.includes("[group=0004 type=0007 params=00 00 00 00]")) {
                res = res.replace(
                    "[group=0004 type=0007 params=00 00 00 00]",
                    t("translation:CommonMsg.Coop.CoopEnemy." + props.content.Sub1_Str)
                )
            }
            if (res.includes("[group=0004 type=000e params=00 00 00 00]")) {
                res = res.replace(
                    "[group=0004 type=000e params=00 00 00 00]",
                    t("translation:CommonMsg.Coop.CoopStageName." + props.content.Sub1_Str)
                )
            }
            if (res.includes("[group=0004 type=000f params=00 00 00 00]")) {
                res = res.replace(
                    "[group=0004 type=000f params=00 00 00 00]",
                    t(
                        "translation:CommonMsg.Gear.GearBrandName." +
                            `B${("" + props.content.Sub1_Int).padStart(2, "0")}`
                    )
                )
            }
            if (res.includes("[group=0004 type=0001 params=00 00 00 00]")) {
                if (props.content.Category === "WeaponLevel") {
                    res = res.replace(
                        "[group=0004 type=0001 params=00 00 00 00]",
                        t("translation:CommonMsg.Weapon.WeaponName_Main." + weapon_dict[props.content.Sub1_Int].__RowId)
                    )
                } else if (props.content.Category === "WinCount_WeaponSp") {
                    res = res.replace(
                        "[group=0004 type=0001 params=00 00 00 00]",
                        t(
                            "translation:CommonMsg.Weapon.WeaponName_Special." +
                                special_dict[props.content.Sub1_Int].__RowId
                        )
                    )
                } else {
                    console.error(props.content)
                }
            }
            return res
        } else {
            return t("translation:CommonMsg.Badge.BadgeMsg." + props.content.Name)
        }
    }

    function badge_image_format() {
        const v = props.content.__RowId.replace("Work/Gyml/BadgeInfo", "Badge").replace(".spl__BadgeInfo.gyml", "")
        return `https://leanny.github.io/splat3/images/badge/${v}.png`
    }

    function get_current_value() {
        switch (props.content.Category) {
            case "CatalogueLevel":
                if (Object.values(profile.Season).filter(entry => entry.CatalogBookCompleteNum > 0).length > 0) {
                    return 100
                }
                return Math.max(0, ...Object.values(profile.Season).map(elem => elem.CatalogLevel))

            case "CoopBossKillNum":
                return profile.Coop.BossKillNumMap[coopRareEnemy_dict[props.content.Sub1_Str]] ?? 0
            case "CoopRareEnemyKillNum":
                return profile.Coop.RareEnemyKillNumMap[coopRareEnemy_dict[props.content.Sub1_Str]] ?? 0
            case "LimitedRewardLottery":
                return (
                    Object.entries(profile.BynameAdjectiveMap).filter(
                        (k, v) => v && parseInt(k) >= 2500 && parseInt(k) <= 2507
                    ).length +
                    Object.entries(profile.NamePlateBgMap).filter(
                        (k, v) => v && parseInt(k) >= 10001 && parseInt(k) <= 10008
                    ).length
                )
            case "WinCount":
                return profile.Versus.WinCountByRule[mode_dict[props.content.Sub1_Str]] ?? 0
            case "WinCount_Tcl":
                if (props.content.Sub1_Str === "Atk") return profile.Versus.WinCountByTclAtk ?? 0
                if (props.content.Sub1_Str === "Def") return profile.Versus.WinCountByTclDef ?? 0
                return 0
            case "WinCount_WeaponSp":
                return profile.Versus.WinCountBySpecial[props.content.Sub1_Int] ?? 0
            case "PlayerRank":
                return profile.Level ?? 1
            default:
                console.log(props.content.Category)
                return 0
        }
    }

    function getProgress() {
        const maximum_value = props.content.Sub2_Int || props.content.Sub1_Int
        const current = Math.min(get_current_value(), maximum_value)
        return <ProgressBar now={current} striped={true} max={maximum_value} label={`${current}/${maximum_value}`} />
    }

    return (
        <div className={classes.BadgeInfo}>
            <div className={classes.BadgeDesc}>{format_description()}</div>
            <div className={classes.BadgeImage}>
                <img src={badge_image_format()} alt={props.content.__RowId} width={128} />
            </div>
            <div className={classes.BadgeProgress}>{getProgress()}</div>
        </div>
    )
}

export default BadgePage
